import { createFileRoute } from "@tanstack/react-router";
import { type } from "arktype";
import { LoginForm } from "~/components/views/auth/login-form";

export const Route = createFileRoute("/auth/login")({
	component: Page,
	validateSearch: type({
		hintEmail: type("string").optional(),
		redirect: type("string").optional(),
	}),
});

function Page() {
	const { hintEmail, redirect } = Route.useSearch();

	return (
		<LoginForm
			hintEmail={hintEmail}
			redirect={redirect ? { href: redirect } : undefined}
		/>
	);
}
